"use client";
import { getSearchPayload, loading } from "@/lib/features/hotel/hotelSlice";
import { useAppSelector } from "@/lib/hooks";
import { parseQueryString } from "@/utils/queryString";
import { useSearchParams } from "next/navigation";
import { useMemo, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
interface TopHeaderFilterProps {
  hotels: any;
}
export const TopHeaderFilter = ({ hotels }: TopHeaderFilterProps) => {
  const [selectedSort, setSelectedSort] = useState("");
  const searchPayload = useAppSelector(getSearchPayload);

  const query: any = useSearchParams();
  // Parse the query string into a payload using parseQueryString
  const payloadFromQuery = useMemo(() => {
    if (!query) return null; // Handle case where searchParams isn't ready
    return parseQueryString(query);
  }, [query]);

  const id: any = payloadFromQuery?.location?.code;
  const response = searchPayload && searchPayload[id];
  const location = response?.location;
  const isLoading = useAppSelector(loading);

  return (
    <>
      <div className="row y-gap-10 items-center justify-between">
        {hotels?.no_of_hotels > 0 && <div className="col-auto">
          <div className="text-18">
            <span className="fw-500">
              {isLoading ? (
                <Skeleton width={200} height={24} />
              ) : (
                <span>
                  {hotels?.no_of_hotels} properties in {location?.name}
                </span>
              )}
            </span>
          </div>
        </div>}
        {/* End .col */}

        <div className="col-auto">
          <div className="row x-gap-20 y-gap-20">
            <div className="col-auto">
              {/* <button className="button -blue-1 h-40 px-20 rounded-100 bg-blue-1-05 text-15 text-blue-1">
                <i className="icon-up-down text-14 mr-10" />
                Top picks for your search
              </button> */}
            </div>
            {/* End .col */}

            <div className="col-auto d-none xl:d-block">
              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#listingSidebar"
                className="button -blue-1 h-40 px-20 rounded-100 bg-blue-1-05 text-15 text-blue-1"
              >
                <i className="icon-up-down text-14 mr-10" />
                Filter
              </button>
            </div>
            {/* End .col */}
          </div>
          {/* End .row */}
        </div>
        {/* End .col */}
      </div>
      {/* End .row */}
    </>
  );
};
